import {Component, Input} from '@angular/core';
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {IGameInstance} from "../../interfaces/IGameInstance";
import {GameInstanceStatuses} from "../../enum/GameInstanceStatusEnum";
import {MatStep, MatStepLabel, MatStepper} from "@angular/material/stepper";
import {PermissionTypes} from "../../enum/PermissionTypes";
import {MatIcon} from "@angular/material/icon";
import {MatButton} from "@angular/material/button";
import {ChooseGameInstanceComponent} from "../../components/choose-game-instance/choose-game-instance.component";
import {MatTabsModule} from "@angular/material/tabs";
import {
  StandardGameReportComponent
} from "../../components/reporting/standard-game-report/standard-game-report.component";
import {HasPermissionDirective} from "../../directives/permissions/has-permission";
import {AuditingReportComponent} from "../../components/reporting/auditing-report/auditing-report.component";
import {SalesPerGameComponent} from "../../components/reporting/sales-per-game/sales-per-game.component";
import {HourlyTicketSalesComponent} from "../../components/reporting/hourly-ticket-sales/hourly-ticket-sales.component";
import {
  DateRangeReportingComponent
} from "../../components/reporting/date-range-reporting/date-range-reporting.component";
import {ColComponent, ListGroupDirective, ListGroupItemDirective, RowComponent} from "@coreui/angular";
import {
  GameCharitySupporterBreakdownComponent
} from "../../components/reporting/game-charity-supporter-breakdown/game-charity-supporter-breakdown.component";
import {ReportingScreenUIState} from "../../enum/ReportingScreenUIState";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {
  LotteryLicenseReportingComponent
} from "../../components/reporting/lottery-license-reporting/lottery-license-reporting.component";
import {PayoutReportComponent} from "../../components/reporting/payout-report/payout-report.component";

@Component({
  selector: 'app-reports',
  standalone: true,
  templateUrl: './reports.component.html',
  imports: [
    MatIcon,
    MatButton,
    MatStepper,
    MatStep,
    MatStepLabel,
    ChooseGameInstanceComponent,
    MatTabsModule,
    StandardGameReportComponent,
    HasPermissionDirective,
    AuditingReportComponent,
    SalesPerGameComponent,
    HourlyTicketSalesComponent,
    DateRangeReportingComponent,
    RowComponent,
    ColComponent,
    GameCharitySupporterBreakdownComponent,
    ListGroupDirective,
    ListGroupItemDirective,
    MatCard,
    MatCardHeader,
    MatCardContent,
    MatCardTitle,
    LotteryLicenseReportingComponent,
    PayoutReportComponent
  ],
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {

  @Input() set gameSetter(gameP: IGameQueryResult) {
    this.activeGame = gameP;
  }

  public permissionTypes = PermissionTypes;
  public activeGame: IGameQueryResult | null = null;
  public chosenGameInstance: IGameInstance | null = null;
  public chosenReportingView: ReportingScreenUIState = ReportingScreenUIState.MultipleDrawReporting;
  public reportingScreenUIState = ReportingScreenUIState;
  public gameInstanceStatusesForTemplate = GameInstanceStatuses;

  selectedTab: number = 0;

  public updateChosenGameInstance(gameInstance: IGameInstance, stepperP: MatStepper) {
    this.chosenGameInstance = gameInstance;
    stepperP.next();
  }

  public resetActiveGameInstance(stepperP: MatStepper) {
    this.chosenGameInstance = null;
    stepperP.previous();
  }

  public updateReportingScreen(reportingViewP: ReportingScreenUIState) {
    this.chosenReportingView = reportingViewP;
  }
}
